import React, { useState, useEffect } from "react";
import { Briefcase, Building2, Scale } from "lucide-react";
import { apiGetAll } from "../igualdad-api.js";
import { useIgualdad } from "../igualdad-store.jsx";

/* ============================================================
   Talention — Panel
   Pantalla de aterrizaje: los KPI del catalogo de la empresa activa.
   Hasta la retirada del motor de valoracion (spec 2026-09-09) tenia una
   segunda capa con el progreso del proyecto de valoracion activo.
   ============================================================ */

/* Marca de "aqui todavia no hay nada cargado". No es un id valido ni null,
   que son valores legitimos de empresa. */
const NADA = -1;

function Panel() {
  const { session, fireToast } = useIgualdad();
  const [puestos, setPuestos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  // Marca a que empresa pertenecen los datos ya en memoria. Un booleano
  // "cargando" no sirve: cuando el id cambia hay un render con el id nuevo y
  // los datos viejos, antes de que el efecto llegue a levantarlo.
  const [empresaCargada, setEmpresaCargada] = useState(NADA);
  const cargado = empresaCargada === session.clienteId;

  useEffect(() => {
    let vivo = true;
    const cliente = session.clienteId;
    Promise.all([
      apiGetAll("/puestos", { cliente_id: cliente }),
      apiGetAll("/departamentos", { cliente_id: cliente }),
    ])
      .then(([pu, de]) => { if (!vivo) return; setPuestos(pu); setDepartamentos(de); setEmpresaCargada(cliente); })
      .catch((e) => { if (!vivo) return; fireToast(e?.message || "No se pudo cargar el panel."); });
    return () => { vivo = false; };
  }, [session.clienteId]);

  return (
    <div className="rb-page">
      <div className="rb-pagehead">
        <div>
          <div className="rb-eyebrow">Visión global</div>
          <h1 className="rb-h1">{session.cliente?.nombre || "Panel"}</h1>
          <p className="rb-sub">{session.user?.name || "Usuario"}</p>
        </div>
      </div>

      <div className="rb-tilerow">
        <Kpi id="puestos" icono={<Briefcase size={16} />} label="Puestos" valor={puestos.length} nota="del catálogo" />
        <Kpi id="departamentos" icono={<Building2 size={16} />} label="Departamentos" valor={departamentos.length} nota="áreas activas" />
        <Kpi id="politicas" icono={<Scale size={16} />} label="Políticas retributivas" valor={session.politicas.length} nota="del registro" />
      </div>

      {cargado && puestos.length === 0 ? (
        <div className="rb-card">
          <p className="rb-empty">Todavía no hay puestos en el catálogo de esta empresa.</p>
        </div>
      ) : null}
    </div>
  );
}

function Kpi({ id, icono, label, valor, nota }) {
  return (
    <div className="rb-tile">
      <div className="rb-tile-h">{icono} {label}</div>
      <div className="rb-tile-big" data-testid={`kpi-${id}`}>{valor}</div>
      <div className="rb-soft rb-xs">{nota}</div>
    </div>
  );
}

export { Panel };
